export const NAME_REGEX = /^([ \u00c0-\u01ffa-zA-Z'])+$/g;

export const PHONE_REGEX = /^([+]\d{2})?\s?(\d{3}\s?){2}\d{3}$/g;

export const RUT_REGEX = /\d{1,2}[.,]?\d{3}[.,]?\d{3}-?[0-9kK]{1}/g;

export const NOT_NUMBER_REGEX = /([^0-9\b])+/;
